import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  Renderer2
} from '@angular/core';

@Directive({
  selector: '[imageLoader]'
})
export class ImageLoaderDirective implements OnInit {
  @Input() imageLoader;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {}

  @HostListener('load')
  onLoad() {}

  @HostListener('error')
  onError() {
    this.renderer.setAttribute(
      this.elementRef.nativeElement,
      'src',
      this.imageLoader ? this.imageLoader : 'assets/img/no-image.png'
    );
  }

  ngOnInit() {
    this.renderer.setAttribute(
      this.elementRef.nativeElement,
      'src',
      this.imageLoader ? this.imageLoader : 'assets/img/loading.svg'
    );
  }
}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/shared/image-loader/image-loader.directive.ts